export function findRelativeParent(targetElement: Element) {
  if (targetElement.getRootNode() === targetElement) {
    return undefined;
  }

  const relativeParents = [];

  let targetParent: Node | null = targetElement.parentNode;

  while (targetParent) {
    if (targetParent instanceof ShadowRoot) {
      targetParent = targetParent.host;

      continue;
    }

    if (!(targetParent instanceof Element)) {
      targetParent = targetParent.parentNode;

      continue;
    }

    const { position } = getComputedStyle(targetParent);

    if (['fixed', 'relative', 'absolute'].includes(position)) {
      relativeParents.push(targetParent);
    }

    if (relativeParents.length === 2) {
      return relativeParents;
    }

    targetParent = targetParent.parentNode;
  }

  if (relativeParents.length < 2) {
    relativeParents.push(document.documentElement);
  }

  return relativeParents;
}
